import { useEffect, useState } from 'react'

// Vrai sur un écran de téléphone (moins de 768 px de large, comme le « md » de Tailwind)
export function useIsPhone(): boolean {
  const query = '(max-width: 767px)'
  const [isPhone, setIsPhone] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches)
  useEffect(() => {
    const mq = window.matchMedia(query)
    const onChange = () => setIsPhone(mq.matches)
    mq.addEventListener('change', onChange)
    return () => mq.removeEventListener('change', onChange)
  }, [])
  return isPhone
}
